export const DELETE_INCOMING_EMAIL = (t) =>
  t('This will stop blocking incoming emails from the specified email.');
export const DELETE_INCOMING_DOMAIN = (t) =>
  t('This will stop blocking incoming emails from the specified domain.');
export const DELETE_OUTGOING = (t) =>
  t('This will stop blocking outgoing emails from the connected inboxes.');
